import React from 'react'
import { useTranslation } from 'react-i18next';

const Pagination = ({page,setPage}) => {
    const {t} = useTranslation()
    return (
        <div className="pagination-div text-center mt-4">
            <nav aria-label="...">
                <ul className="pagination justify-content-center">
                    <li
                        style={{ cursor: "pointer" }}
                        className={page == 0 ? "page-item disabled" : "page-item"}
                        onClick={() => {
                            if (page >= 1) {
                                setPage(page - 1);
                            }
                        }}
                    >
                        <span className="page-link">{t("common.previous")}</span>
                    </li>
                    <li className="page-item active">
                        <span className="page-link">{page + 1}</span>
                    </li>
                    <li
                        className="page-item"
                        onClick={() => {
                            setPage(page + 1);
                        }}
                    >

                        <span className="page-link">{t("common.next")}</span>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Pagination